import components from "./component";
import { makeInstaller } from './make-installer'

export default makeInstaller(components)
